module.exports = __webpack_public_path__ + "static/clip-2-06ace515c053a1ff3c49fe38d00ecaec.jpg";